module.exports = __webpack_public_path__ + "img/48x48_time@2x.451fbe4d.png";